import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=318a6773&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"
import style0 from "./HeaderPage.vue?vue&type=style&index=0&id=318a6773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a6773",
  null
  
)

export default component.exports